import React from "react";
import { ScrollView, StyleSheet, TextInput, View } from "react-native";
import S3Image from "screens/common/S3Image";
import { PopularFAs } from "screens/LoginRegistration/components/FAComponent/constants";
import FAList from "screens/LoginRegistration/components/FAComponent/FAList";
import FilteredFAList from "screens/LoginRegistration/components/FAComponent/FilteredFAList";
import SelectedFAList from "screens/LoginRegistration/components/FAComponent/SelectedFAList";
import NavHeader from "screens/LoginRegistration/utils/NavHeader";
import SText from "styled42/components/SText";
import { Colors } from "styled42/config";
import { pushClevertapEvent } from "utils/clevertapEvents";
import VernacManager from "utils/vernacular";

class FAListView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      isSearchFocused: false
    };
  }

  onSearchFocusHandler = () => {
    const { variant } = this.props;
    pushClevertapEvent(`loginRegister Clicks`, {
      Test_Case: variant,
      Type: "FA Search"
    });
    this.setState({
      isSearchFocused: true
    });
  };

  onSearchBlurHandler = () => {
    this.setState({
      isSearchFocused: false
    });
  };

  onSearchSelectHandler = (...params) => {
    const { onFASelectHandler } = this.props;
    onFASelectHandler(...params);
    this.setState({
      searchText: ""
    });
  };

  onSearchHandler = (text) => {
    this.setState({
      searchText: text
    });
  };

  onBackHandler = () => {
    const { variant, goBack, onViewModeChange } = this.props;
    pushClevertapEvent(`loginRegister Clicks`, {
      Test_Case: variant,
      Page_Modal: "FA Select",
      Type: "Back"
    });
    if (variant === "C") {
      onViewModeChange("GRID");
    } else {
      goBack();
    }
  };

  render() {
    const {
      selectedFAList,
      fullFAList,
      selectedFAIds,
      onFASelectHandler,
      onFADeleteHandler,
      variant
    } = this.props;
    const { searchText, isSearchFocused } = this.state;

    return (
      <>
        <NavHeader
          progressStatus={variant === "B" ? 2 : 3}
          maxValue={variant === "B" ? 2 : 3}
          primaryText=""
          secondaryText=""
          containerStyle={styles.navheader}
          onBack={this.onBackHandler}
        />
        <View style={styles.greyContainer}>
          <View>
            <SText style={styles.headerTxt}>
              {VernacManager.translateString("job_interest_select_jobs")}{" "}
              <SText style={styles.headerTxtBold}>
                {VernacManager.translateString("job_interest_interest")}
              </SText>
            </SText>
            <SText style={styles.subHeaderTxt}>
              {VernacManager.translateString("job_interest_select_upto")}
            </SText>
          </View>
          {/* <SelectedFAList
            selectedFAList={selectedFAList}
            onDelete={onFADeleteHandler}
          /> */}
          <View
            style={[
              styles.inputContainer,
              isSearchFocused && styles.focusedInput
            ]}
          >
            <S3Image
              path="RocketIntegration"
              name="SearchIcon"
              style={styles.inputIcon}
            />
            <TextInput
              blurOnSubmit={false}
              keyboardType="default"
              placeholder={VernacManager.translateString(
                "generic_search_job_categories"
              )}
              placeholderTextColor={Colors.Grey[5]}
              value={searchText}
              style={styles.input}
              onFocus={this.onSearchFocusHandler}
              onBlur={this.onSearchBlurHandler}
              onChangeText={this.onSearchHandler}
            />
          </View>
        </View>
        <ScrollView
          showsVerticalScrollIndicator={false}
          style={styles.container}
        >
          {searchText ? (
            <FilteredFAList
              faList={fullFAList}
              searchText={searchText}
              selectedFAIds={selectedFAIds}
              onSelect={this.onSearchSelectHandler}
            />
          ) : (
            <>
              <FAList
                showListItemImage
                // title="Popular jobs for you"
                titleProps={{
                  size: 12,
                  weight: "500",
                  color: "#8A8A8A"
                }}
                listKey="popular-list"
                faList={PopularFAs}
                selectedFAIds={selectedFAIds}
                onSelect={onFASelectHandler}
              />
              <FAList
                title={VernacManager.translateString("generic_all_jobs")}
                titleProps={{
                  size: 16,
                  weight: "500"
                }}
                listKey="other-list"
                faList={fullFAList}
                selectedFAIds={selectedFAIds}
                onSelect={onFASelectHandler}
              />
            </>
          )}
        </ScrollView>
      </>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    marginTop: 20
  },
  navheader: {
    backgroundColor: "transparent"
  },
  greyContainer: {
    marginTop: 28,
    paddingHorizontal: 16,
    backgroundColor: "transparent"
  },
  loaderContainer: {
    margin: 15,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    height: "100%"
  },
  inputContainer: {
    marginTop: 16,
    marginBottom: -20,
    backgroundColor: "#ffffff",
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#adacb6",
    borderRadius: 4,
    overflow: "hidden"
  },
  input: {
    width: "100%",
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 14,
    color: Colors.BlueGrey[12],
    lineHeight: 20
  },
  focusedInput: {
    borderBottomWidth: 2,
    borderBottomColor: "#1B2D93"
  },
  inputIcon: {
    width: 13,
    height: 14,
    marginHorizontal: 8
  },
  headerTxt: {
    fontSize: 20,
    fontWeight: "500"
  },
  headerTxtBold: {
    fontSize: 20,
    fontWeight: "700"
  },
  subHeaderTxt: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "500",
    color: "#696F7C"
  }
});

export default FAListView;
